(function () {
  'use strict';
  var watched = new WeakSet();
  var pending = false;
  var selectors = '#shopify-pc__banner, #stickyCart, #mobile-bar, .ways-service-actions';
  function visible(el) { return el && getComputedStyle(el).display !== 'none' && el.getBoundingClientRect().height > 0; }
  function sync() {
    pending = false;
    var mobile = window.matchMedia('(max-width: 991px)').matches;
    var banner = document.getElementById('shopify-pc__banner');
    document.body.classList.toggle('cookie-banner-visible', mobile && visible(banner));
    var height = 0;
    document.querySelectorAll('#stickyCart, #mobile-bar, .ways-service-actions').forEach(function (bar) {
      if (mobile && visible(bar)) height = Math.max(height, Math.ceil(bar.getBoundingClientRect().height));
    });
    var value = height + 'px';
    if (document.body.style.getPropertyValue('--ways-mobile-bar-height') !== value) {
      document.body.style.setProperty('--ways-mobile-bar-height', value);
    }
  }
  function schedule() {
    if (pending) return;
    pending = true;
    window.requestAnimationFrame(sync);
  }
  var resizeObserver = window.ResizeObserver ? new ResizeObserver(schedule) : null;
  function discover() {
    document.querySelectorAll(selectors).forEach(function (el) {
      if (watched.has(el)) return;
      watched.add(el);
      if (resizeObserver) resizeObserver.observe(el);
      new MutationObserver(schedule).observe(el, {attributes:true, attributeFilter:['style','class','hidden']});
    });
    schedule();
  }
  function init() {
    new MutationObserver(discover).observe(document.body, {childList:true, subtree:true});
    window.addEventListener('resize', schedule, {passive:true});
    discover();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, {once:true});
  else init();
})();
